export { default } from './Button'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Button/index.js